<template>
  <div :class="containerClass">
    <IconButton
      v-if="isUpdateAvailable(item)"
      :class="iconButtonClass"
      :href="adBridgeSetupUrl"
      rel="noopener noreferrer"
      target="_blank"
      title="Install a new Import Agent"
    >
      <DownloadIcon />
    </IconButton>
    <IconButton
      v-if="item.state === active"
      :class="iconButtonClass"
      title="Deactivate"
      @click="handleDeactivate"
    >
      <PauseActionIcon />
    </IconButton>
    <IconButton
      v-else
      :class="iconButtonClass"
      title="Activate"
      @click="handleActivate"
    >
      <RefreshIcon />
    </IconButton>
    <IconButton
      v-if="checkIfContactIsOverdue"
      :class="iconButtonClass"
      title="Delete"
      @click="handleDelete"
    >
      <TrashIcon />
    </IconButton>
  </div>
</template>
<script>
import { AdBridgeAgentStates, ItemTypeConsts, StoreModuleMap } from 'client/util/Constants';
import { mapActions, mapGetters, mapState } from 'vuex';
import DownloadIcon from 'public/img/icons/actions-down.svg?inline';
import IconButton from 'client/components/Buttons/IconButton.vue';
import PauseActionIcon from 'public/img/icons/pauseAction.svg?inline';
import RefreshIcon from 'public/img/icons/refresh.svg?inline';
import TrashIcon from 'public/img/icons/trash.svg?inline';

const storeModule = StoreModuleMap[ItemTypeConsts.adBridgeAgent];

export default {
  name: 'AdBridgeImportAgentActions',

  components: {
    DownloadIcon,
    IconButton,
    PauseActionIcon,
    RefreshIcon,
    TrashIcon,
  },

  props: {
    containerClass: {
      type: String,
      default: '',
    },
    handleDelete: {
      type: Function,
      required: true,
    },
    iconButtonClass: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      ...AdBridgeAgentStates,
    };
  },

  computed: {
    ...mapGetters(storeModule, [
      'isContactOverdue',
      'isUpdateAvailable',
    ]),

    ...mapState('SettingsModule', [
      'adBridgeSetupUrl',
    ]),

    checkIfContactIsOverdue() {
      return this.isContactOverdue(this.item.id);
    },
  },

  methods: {
    ...mapActions(storeModule, [
      'activate',
      'deactivate',
    ]),

    handleActivate() {
      this.activate(this.item.id);
    },

    handleDeactivate() {
      this.deactivate(this.item.id);
    },
  },
};
</script>
